'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'rv';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f7be';
var svgPathData = 'M208 0l-8 0 0 32-200 0 0 306.8 1.8 2.2 64 80 .2 .3c-1.3 6-2 12.3-2 18.7 0 48.6 39.4 88 88 88 45.9 0 83.6-35.1 87.6-80l112.7 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l48.4 0 0-154.7-1.6-2.1-72-96-2.4-3.2-132 0 0-32 208 0 0-128-200 0 0-32-168 0zM368 208l124 0 60 80-184 0 0-80zm0 181.4l0-85.4 192 0 0 128-32.4 0c-4-44.9-41.7-80-87.6-80-29.8 0-56.1 14.8-72 37.4zM352 432l-112.4 0c-4-44.9-41.7-80-87.6-80-35.5 0-66 21-80 51.2l-56-70 0-285.2 200 0 0-32 144 0 0 32 200 0 0 96-208 0 0 288zM152 368a72 72 0 1 1 0 144 72 72 0 1 1 0-144zm288 0a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM104 128l-8 0 0 128 192 0 0-128-184 0zm8 112l0-96 160 0 0 96-160 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRv = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;